import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@material-ui/core";
import { FC, useRef, useState } from "react";
import FormikForm, {
  FormikStep,
} from "src/components/ui-components/FormikForm";
import SelectField from "src/components/ui-components/SelectField";
import * as Yup from "yup";

interface ModalProps {
  open: boolean;
  handleClose: () => void;
  handleLanguageSave?: (values: any) => Promise<void>;
  languageMaster?: any;
  regionMaster?: any;
}

const defaultForm = {
  language: "",
  regionCode: "",
};

const LanguageModal: FC<ModalProps> = ({
  open,
  handleClose,
  handleLanguageSave,
  regionMaster,
  languageMaster,
}: ModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const formRef = useRef(null);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="Language Create Edit"
      aria-describedby="Create Edit Form for Language"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "auto",
      }}
    >
      <Box
        sx={{ bgcolor: "background.paper", boxShadow: 24, p: 4, width: "50%" }}
      >
        <Typography
          sx={{ marginBottom: "2%", fontWeight: "bold" }}
          variant="h5"
        >
          Create Language
        </Typography>
        <FormikForm
          innerRef={formRef}
          initialValues={defaultForm}
          onSubmit={async (values) => {
            setIsLoading(true);
            await handleLanguageSave(values);
            setIsLoading(false);
          }}
        >
          <FormikStep
            validationSchema={Yup.object({
              language: Yup.string()
                .nullable()
                .required("Language is required"),
              regionCode: Yup.string()
                .nullable()
                .required("Region is required"),
            })}
          >
            <Grid spacing={2} container>
              <Grid item xs={6}>
                <SelectField
                  data={languageMaster}
                  dataTextField="language"
                  dataValueField="language"
                  name="language"
                  label="Language *"
                />
              </Grid>
              <Grid item xs={6}>
                <SelectField
                  data={regionMaster}
                  dataTextField="country"
                  dataValueField="regionCode"
                  name="regionCode"
                  label="Region Code *"
                />
              </Grid>
            </Grid>
            <Grid
              spacing={2}
              container
              justifyContent="end"
              sx={{ paddingTop: "15px" }}
            >
              <Button
                sx={{
                  minWidth: 100,
                  marginTop: "2%",
                  marginRight: "2%",
                  color: "rgb(107, 119, 140)",
                }}
                disabled={isLoading}
                variant="outlined"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                sx={{
                  minWidth: 100,
                  marginTop: "2%",
                  marginRight: "2%",
                  color: "rgb(107, 119, 140)",
                }}
                disabled={isLoading}
                variant="outlined"
                type="submit"
              >
                Save
                {isLoading && (
                  <CircularProgress
                    color="inherit"
                    thickness={5}
                    size={20}
                    sx={{ ml: 1 }}
                  />
                )}
              </Button>
            </Grid>
          </FormikStep>
        </FormikForm>
      </Box>
    </Modal>
  );
};

export default LanguageModal;
